<template>
    <zen-one
        :showuserinfo="false"
        title="Cukai Tanah:: Ampun Hasil"
        :crumbs="crumbs"
    >
        <z-page :title="`Senarai Ampun Hasil (${total})`" :append-button="true">
            <w-flex column :gap="3">
                <w-form @submit.prevent="filter">
                    <w-flex column :gap="3">
                        <w-flex :columns="{ xs: 1 }" :gap="3">
                            <w-input v-model="searchParams.no_hm"
                                >No. HM</w-input
                            >
                            <w-input v-model="searchParams.no_tauliah"
                                >No. MMK</w-input
                            >
                            <w-input v-model="searchParams.pemilik"
                                >Nama Pemilik</w-input
                            >
                            <w-input v-model="searchParams.keterangan"
                                >Kategori</w-input
                            >
                            <w-select
                                :items="[
                                    { value: 'null', label: 'Semua' },
                                    { value: '1', label: 'Aktif' },
                                    { value: '0', label: 'Tidak Aktif' },
                                ]"
                                label="Status"
                                v-model="searchParams.status"
                            ></w-select>

                            <w-select
                                :items="districts"
                                label="Daerah"
                                v-model="searchParams.daerah"
                                :disabled="this.id_daerah >1"
                                style="color:blue;"
                            ></w-select>

                        </w-flex>

                        <div class="mt2 text-right">
                                     <w-button
                                     bg-color="success"
                                     class="ml1 "
                                     :loading="loading" @click="printExcel()">
                                     <w-icon v-on="on" class=" mr2 "> fal fa-print</w-icon>
                                         &nbsp;Cetak&nbsp;
                                     </w-button>

                                     <w-button
                                     bg-color="primary"
                                     class="ml1 "
                                     :loading="loading"
                                     type="submit"
                                     >
                                         <w-icon>fal fa-search</w-icon>&nbsp;Cari
                                     </w-button>
                        </div>

                    </w-flex>
                </w-form>
                <w-flex class="justify-end">
                    <w-button class="align-self-end" @click="semakHakmilik" :loading="loading" >
                        Tambah Ampun Hasil&nbsp;
                        <w-icon> fal fa-plus </w-icon>
                    </w-button>
                </w-flex>

                <Table
                    :headers="ampunHasil.headers"
                    :items="loading ? [] : ampunHasil.items"
                    :loading="loading"
                >
                    <template #item-cell.id="{ item, label, header, index }">
                        {{
                            (pagination.currentPage - 1) * pagination.perPage +
                            index
                        }}
                    </template>

                    <template
                        #item-cell.tarikh_mula="{ item, label, header, index }"
                    >
                    <div v-if="item.tarikh_mula!=null">
                        {{ moment(item.tarikh_mula).format("DD-MM-YYYY") }}
                    </div>
                    <div v-else>
                        Tiada Tarikh Mula
                    </div>
                    </template>

                    <template
                        #item-cell.tarikh_tamat="{ item, label, header, index }"
                    >
                    <div v-if="item.tarikh_tamat!=null">
                        {{ moment(item.tarikh_tamat).format("DD-MM-YYYY") }}
                    </div>
                    <div v-else>
                        Tiada Tarikh Tamat
                    </div>
                    </template>

                    <template
                        #item-cell.file="{ item, label, header, index }"
                    >
                        <w-button v-if="item.file"
                            @click="dokumen(item.file)"
                        >
                            <w-tooltip top>
                                <template #activator="{ on }">
                                    <w-icon v-on="on"> fal fa-file </w-icon>
                                </template>
                                Papar
                            </w-tooltip>
                        </w-button>
                        <h1 v-else>Tiada</h1>
                    </template>
                    <template
                        #item-cell.action="{ item, label, header, index }"
                    >
                        <inertia-link
                            :href="$route('cukai-tanah.kemaskiniAmpun')"
                            :data="{ no_hm: item.no_hm }"
                        >
                            <w-tooltip top>
                                <template #activator="{ on }">
                                    <w-icon v-on="on"> fal fa-pencil </w-icon>
                                </template>
                                Papar
                            </w-tooltip>
                        </inertia-link>
                    </template>
                </Table>
                <TablePagination
                    :lastPage="getLastPage"
                    :currentPage="pagination.currentPage"
                    :perPage="pagination.perPage"
                    @onClick="onPaginationChange($event)"
                />
            </w-flex>
            <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
        <w-alert error outline v-if="hasSearched && hm.length == 0"
            >Tiada hak milik ditemui.</w-alert
        >
         <SemakHakMilikForm
            :districts="districts"
            :mukim="[]"
            :jhm="[]"
            :searching="searching"
            :form="form"
            @onSemak="onSemak"
            :byBarcode="true"
            :byIdHM="false"
            :byMukimNoHM="false"
            :byJenisNoHM="false"
        ></SemakHakMilikForm>


        </w-dialog>
        </z-page>
    </zen-one>
</template>

<script>
import moment from "moment";
import ZResource from "@/Modules/z-resource";
import Table from "../Component/Table";
import TablePagination from "../Component/TablePagination";
import SemakHakMilikForm from "../Component/SemakHakMilikForm";

export default {
    extends: ZResource,
    components: { Table, TablePagination, SemakHakMilikForm },
    data() {
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            loading: false,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Senarai", route: "/cukai-tanah/senarai" },
            ],
            total: 0,
            pagination: {
                perPage: 10,
                currentPage: 1,
                lastPage: 1,
            },
            statusOptions: [
                { value: "null", label: "Semua" },
                { value: "1", label: "Aktif" },
                { value: "0", label: "Tidak Aktif" },
            ],

            ampunHasil: {
                headers: [
                    { label: "No. Hak Milik", key: "no_hm" },
                    { label: "No. MMK", key: "no_tauliah" },
                    { label: "Pemilik", key: "pemilik" },
                    { label: "No. KP", key: "no_kp" },
                    { label: "Keluasan", key: "keluasan" },
                    // { label: "Keluasan Maksimum", key: "keluasan_mak" },
                    { label: "Kategori", key: "kategori" },
                    // { label: "Amaun Cukai (RM)", key: "amaun_cukai" },
                    { label: "Amaun Ampun (RM)", key: "amaun" },
                    // { label: "Peratus Ampun", key: "peratus_ampun" },
                    { label: "Tempoh Mula", key: "tarikh_mula" },
                    { label: "Tempoh Tamat", key: "tarikh_tamat" },
                    { label: "Status", key: "status" },
                    { label: "Dokumen", key: "file", align: "center" },
                    { label: "Tindakan", key: "action", align: "center" },
                ],
                items: [],
            },
            searchParams: {
                no_tauliah: null,
                pemilik: null,
                keterangan: null,
                status: null,
                no_hm: null,
                daerah:null,
            },
            dialog:{
                show: false
            },
            searching: false,
            hasSearched: false,
            form: {
                kod_daerah: "01",
                form_option: "option1",
                kategori_carian: "1",
                barcode: null,
                kod_mukim: null,
                kod_jenis_hm: null,
                tarikh_daftar: null,
                no_hm: "",
                no_bangunan: null,
                no_tingkat: null,
                no_petak: null,
                no_resit: null,
                no_kp: null,
            },
            districts: [{ value: "null", label: "Loading..." },],
            hm:[],
            jabatan:this.$page.props.auth.user.jabatan_id,
            id_daerah:null,
        };
    },
    methods: {
        async onSemak(e){
            this.searching = true;
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/cari`,
                responseType: "json",
                data: this.form,
            })
                .then((e) => {
                    this.hm = e.data;
                    if (e.data.length > 0) {
                        const url = `ampunHasil?no_hm=${this.hm[0].no_hm}`;
                        this.$inertia.get(url);
                    }

                })
                .finally((e) => {
                    this.searching = false;
                    this.hasSearched = true;
                });
        },
        semakHakmilik(){
            this.dialog.show = true;
        },
        dokumen(file){
            // console.log(file);
            var url1 = `${this.apiBaseUrl}/cukai/ampun-hasil/dokumenShow?file=${file}`;
            window.open(url1,"_blank");
        },
        async printExcel(){
            if (this.searchParams.nama == null) {
                delete this.searchParams.nama;
            }
                  for (var key in this.searchParams) {
                    if (String(this.searchParams[key]) === "null" || String(this.searchParams[key]) === "undefined") {
                      delete this.searchParams[key];
                    }
                  }
                var queryString = Object.keys(this.searchParams)
                .map((key) => key + "=" + this.searchParams[key])
                .join("&");
                window.open( `${this.apiBaseUrl}/cukai/ampun-hasil/printExcel?${queryString}`);
        },
        moment(date) {
            return moment(date);
        },
        onPaginationChange(e) {
            this.pagination.currentPage = e.value.currentPage;
            this.pagination.perPage = e.value.perPage;
            this.fetchData2();
        },
        filter() {
            this.searchParams.status =
                this.searchParams.status === "null"
                    ? null
                    : this.searchParams.status;
            this.fetchData2();
        },
        async fetchData2() {
            this.loading = true;
            this.searchParams.limit = this.pagination.perPage;
            this.searchParams.offset =
                (this.pagination.currentPage - 1) * this.pagination.perPage;
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/ampun-hasil`,
                params: this.searchParams,
                responseType: "json",
            }).then((e) => {
                const { limit, offset, total, data } = e.data;
                this.total = total;
                this.pagination.lastPage = Math.ceil(total / limit);
                this.ampunHasil.items = data;
            });
            this.loading = false;
        },
        async fetchDaerah() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah`,
                responseType: "json",
            }).then((e) => {
                this.districts = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.id,
                    };
                });
                this.form.kod_daerah = this.districts[0].value;
            });
        },
        async getDaerah(){
            this.loading = true;
            await axios({
                    method: "get",
                    url: `${this.apiBaseUrl}/jabatanToDaerah?jabatan=${this.jabatan}`,
                    responseType:'json',
                }).then((e)=>{
                    this.searchParams.daerah=e.data[0].lkp_daerah_id;
                    this.id_daerah=e.data[0].lkp_daerah_id;
                    // this.fetchData2();
                }).finally((e) => {
                    this.fetchData2();
                });;
        },
    },
    computed: {
        getLastPage() {
            return this.total > 0
                ? Math.ceil(this.total / this.pagination.perPage)
                : 1;
        },
        getSearch(){

        },
    },
    mounted() {
        this.getDaerah();
        this.fetchDaerah();
    },
};
</script>
<style >

</style>
